
export default ({ request }) => ({
  get_event_records(query) {
    return request({
      url: `/platform/v1/event_records`,
      method: 'get',
      params: query
    })
  },
  get_event_types(params) {
    return request({
      url: `/platform/v1/event_types`,
      method: 'get',
      params: params
    })
  },
  // 获取事件类型列表（不分页），用于下拉选择
  get_event_types_list(params) {
    return request({
      url: `/platform/v1/event_types/list`,
      method: 'get',
      params: params
    })
  },
  create_event_type(data) {
    return request({
      url: `/platform/v1/event_types`,
      method: 'post',
      data: data
    })
  },
  get_event_type(id) {
    return request({
      url: `/platform/v1/event_types/${id}`,
      method: 'get'
    })
  },
  update_event_type(id, data) {
    return request({
      url: `/platform/v1/event_types/${id}`,
      method: 'put',
      data: data
    })
  },
  delete_event_type(id) {
    return request({
      url: `/platform/v1/event_types/${id}`,
      method: 'delete'
    })
  },

  get_event_records(query) {
    return request({
      url: `/platform/v1/event_records`,
      method: 'get',
      params: query
    })
  },
  create_event_record(data) {
    return request({
      url: `/platform/v1/event_records`,
      method: 'post',
      data: data
    })
  },
  get_event_record(id) {
    return request({
      url: `/platform/v1/event_records/${id}`,
      method: 'get'
    })
  },
  update_event_record(id, data) {
    return request({
      url: `/platform/v1/event_records/${id}`,
      method: 'put',
      data: data
    })
  },
  delete_event_record(id) {
    return request({
      url: `/platform/v1/event_records/${id}`,
      method: 'delete'
    })
  },

  // Event Types 相关方法
  get_event_types(params) {
    return request({
      url: `/platform/v1/event_types`,
      method: 'get',
      params: params
    })
  },
  create_event_type(data) {
    return request({
      url: `/platform/v1/event_types`,
      method: 'post',
      data: data
    })
  },
  get_event_type(id) {
    return request({
      url: `/platform/v1/event_types/${id}`,
      method: 'get'
    })
  },
  update_event_type(id, data) {
    return request({
      url: `/platform/v1/event_types/${id}`,
      method: 'put',
      data: data
    })
  },
  delete_event_type(id) {
    return request({
      url: `/platform/v1/event_types/${id}`,
      method: 'delete'
    })
  },

  // 验收完成
  complete_event_review(id) {
    return request({
      url: `/platform/v1/event_records/${id}/complete-review`,
      method: 'post'
    })
  },

  // 驳回处理
  reject_event_review(id, data) {
    return request({
      url: `/platform/v1/event_records/${id}/reject`,
      method: 'post',
      data: data
    })
  },

  // 创建处理记录
  create_handle(data) {
    return request({
      url: `/platform/v1/handles`,
      method: 'post',
      data: data
    })
  },

  // 获取处理记录列表
  get_handles(query) {
    return request({
      url: `/platform/v1/handles`,
      method: 'get',
      params: query
    })
  }
})